import {
	getContractRequiredMinimumRefinement,
	refineContractRequiredMinimum,
} from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import {
	getInvestmentBaseShape,
	refineInvestmentDates,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { getManualValueShape } from "web_myplann/Portfolio/PortfolioShared/getManualValueShape";
import { refineManualValue } from "web_myplann/Portfolio/PortfolioShared/refineManualValue";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { KeyFieldsLockOptions } from "web_myplann/Shared/Validation/lockableField";
import { z } from "zod";

export const getCryptocurrencyCreateFormSchema = (t: TranslateFunction) =>
	z
		.object({
			...getInvestmentBaseShape(t),
			...getManualValueShape(t),
		})
		.superRefine(refineManualValue(t))
		.superRefine(refineInvestmentDates(t))
		.superRefine(refineContractRequiredMinimum);

export const getCryptocurrencyEditFormSchema = (
	t: TranslateFunction,
	options: KeyFieldsLockOptions = {},
) =>
	z
		.object(getInvestmentBaseShape(t, options))
		.superRefine(refineInvestmentDates(t))
		.superRefine(getContractRequiredMinimumRefinement(options));

export type CryptocurrencyCreateFormInput = z.input<
	ReturnType<typeof getCryptocurrencyCreateFormSchema>
>;
export type CryptocurrencyCreateFormOutput = z.output<
	ReturnType<typeof getCryptocurrencyCreateFormSchema>
>;
export type CryptocurrencyEditFormInput = z.input<
	ReturnType<typeof getCryptocurrencyEditFormSchema>
>;
export type CryptocurrencyEditFormOutput = z.output<
	ReturnType<typeof getCryptocurrencyEditFormSchema>
>;
